import React from 'react'
import { TrendUpIcon, TrendDownIcon } from '../Icons'
import './index.sass'

const ChangeCell = ({ value, isPositive }) => {
  if (value === null || value === undefined) {
    return null
  }

  return (
    <div className="markets-table-change">
      <p className={`markets-table-change__value ${isPositive ? 'markets-table-change__value--positive' : 'markets-table-change__value--negative'}`}>
        {isPositive ? '+' : ''}
        {value.toFixed(2)}%
        <span className="markets-table-change__arrow">
          {isPositive ? <TrendUpIcon /> : <TrendDownIcon />}
        </span>
      </p>
    </div>
  )
}

export default ChangeCell

